import type { IconSvgObject } from './types';

const ChevronsUpIcon: IconSvgObject = [
  ["path", { d: "M17 11L12 6L7 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 18L12 13L7 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsUpIcon;
